import React, { useCallback, useEffect, useRef, useState } from "react";
import ViewPost from "../../../components/FeedManagement/ViwePost";
import DeletePost from "../../../components/FeedManagement/DeletePost";
import {
  deleteFeed,
  getFeed,
  pinnedFeed,
} from "../../../features/slices/feedmanagement";

import { getStudentFeed } from "../../../features/slices/studentManagement/studentFeed";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment/moment";
import CommonPagination from "../../../components/CommonPagination";
import ExportToExcel from "../../../components/ExportToExcel";
import { toastService } from "../../../utils/toastify";
import CommentListModal from "../../../components/FeedManagement/CommentListModal";
import TableSkeleton from "../../../components/TableSkeleton";
import { getEmail } from "../../../utils/getToken";
import { useLocation } from "react-router-dom";
const initialState = {
  currentPage: 1,
  searchQuery: "",
  fromDate: "",
  toDate: "",
  timeframe: "",
  status: "",
  showCreatePost: false,
  showPost: false,
  deletePost: false,
  commentList: false,
  is_pinned: "",
  filterStatus: "",
};
const TimelineDetails = () => {
  const [iState, setUpdateState] = useState(initialState);
  const {
    searchQuery,
    fromDate,
    toDate,
    timeframe,
    status,
    showCreatePost,
    showPost,
    deletePost,
    commentList,
    is_pinned,
    filterStatus,
  } = iState;
  const [id, setId] = useState(null);
  const [page, setPage] = useState(1);
  const dispatch = useDispatch();
  const { state } = useLocation();
  const { feed, loading } = useSelector((state) => state?.studentFeed);
  const feedRef = useRef();
  const handleShow = (name, id) => {
    setUpdateState({
      ...iState,
      [name]: true,
    });
    setId(id);
  };
  const handleTimeFrame = (e) => {
    const queryParams = { timeframe: e.target.value, userId: state?._id };
    setUpdateState((prev) => ({
      ...prev,
      timeframe: e.target.value,
    }));
    dispatch(getStudentFeed(queryParams)).then((data) => {
      if (data?.payload?.code === 200) {
        // setUpdateState((prev) => ({
        //   ...prev,
        //   timeframe: "",
        // }));
      }
    });
  };

  useEffect(() => {
    dispatch(getStudentFeed({ userId: state?._id, page }));
    window.scrollTo(0, 0);
  }, [page]);
  const handleCommentList = (postId) => {
    setId(postId);
    setUpdateState((prev) => ({
      ...prev,
      commentList: true,
    }));
  };
  const handleReset = () => {
    setUpdateState(initialState);
    dispatch(getStudentFeed({ page, userId: state?._id }));
  };
  const handleDelete = (reason) => {
    dispatch(
      deleteFeed({
        id,
        status: "DELETED",
        deleteReason: reason,
      })
    ).then((res) => {
      if (res?.payload?.code == 200) {
        dispatch(getStudentFeed({ page, userId: state?._id }));
        handleClose();
      } else {
        toastService.error(res?.payload?.message);
      }
    });
  };
  const handleSearch = (e) => {
    const { name, value } = e.target;
    setUpdateState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleClose = () => {
    setUpdateState((prev) => ({
      ...prev,
      deletePost: false,
    }));
  };
  const pinManagement = (id, status) => {
    dispatch(
      pinnedFeed({
        id: id,
        is_pinned: status,
      })
    ).then((res) => {
      if (res?.payload?.code == 200) {
        status == true
          ? toastService.success("Pinned successfully")
          : toastService.success("Unpinned successfully");
        dispatch(
          getStudentFeed({ page, userId: state?._id, userId: state?._id })
        );
      } else {
        toastService.error(res?.payload?.message);
      }
    });
  };
  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };
  const handleSubmit = () => {
    const queryParams = {
      page: 1,
      search: searchQuery?.trim(),
      status: status,
      userId: state?._id,
    };
    if (fromDate && toDate) {
      queryParams.startDate = fromDate;
      queryParams.endDate = toDate;
    } else if (timeframe) {
      queryParams.timeframe = timeframe;
    }
    dispatch(getStudentFeed(queryParams)).then((data) => {
      if (data?.payload?.code === 200) {
        // setUpdateState((prev) => ({
        //   ...prev,
        //   searchQuery: "",
        //   fromDate: "",
        //   toDate: "",
        //   timeframe: "",
        // }));
      }
    });
  };
  const handleFilter = (e) => {
    const status = e.target.value;
    setUpdateState((prev) => ({
      ...prev,
      status: status,
    }));
    if (status == "pin") {
      setUpdateState((prev) => ({
        ...prev,
        is_pinned: true,
      }));
      dispatch(
        getStudentFeed({
          is_pinned: true,
          search: searchQuery?.trim(),
          userId: state?._id,
        })
      );
    } else if (status == "unpin") {
      dispatch(
        getStudentFeed({
          is_pinned: false,
          userId: state?._id,
        })
      );
    } else {
      setUpdateState((prev) => ({
        ...prev,
        filterStatus: status,
      }));
      dispatch(
        getStudentFeed({
          userId: state?._id,
          status: status,
          search: searchQuery?.trim(),
        })
      );
    }
  };
  useEffect(() => {
    if (searchQuery.trim() !== "") {
      const delayDebounceFunc = setTimeout(() => {
        dispatch(
          getStudentFeed({
            search: searchQuery?.trim(),
            is_pinned,
            status: filterStatus,
            userId: state?._id,
          })
        ).then((res) => {
          if (res?.payload?.code == 200) {
            // setUpdateState((prev) => ({
            //   ...prev,
            //   searchQuery: "",
            // }));
          }
        });
      }, 1000);
      return () => clearTimeout(delayDebounceFunc);
    }
  }, [searchQuery, dispatch]);
  const UserData = getEmail("adminLogin");
  const handleCommentClose = useCallback(() => {
    return setUpdateState((prev) => ({
      ...prev,
      commentList: false,
    }));
  }, []);

  return (
    <>
      <div className="WrapperBox">
        <div className="FilterArea">
          <div className="form-group">
            <label>From Date</label>
            <input
              type="date"
              className="form-control"
              value={fromDate}
              disabled={timeframe}
              name="fromDate"
              onChange={(e) => handleSearch(e)}
            />
          </div>
          <div className="form-group">
            <label>To Date</label>
            <input
              type="date"
              className="form-control"
              name="toDate"
              value={toDate}
              disabled={timeframe}
              onChange={(e) => handleSearch(e)}
            />
          </div>
          <div className="form-group">
            <label>&nbsp;</label>
            <button className="Button" onClick={handleSubmit}>
              Apply
            </button>
          </div>
          <div className="form-group">
            <label>Timeframe</label>
            <select
              className="form-control customSelect"
              name="timeframe"
              value={timeframe}
              disabled={fromDate || toDate}
              onChange={(e) => handleTimeFrame(e)}
            >
              <option value="" hidden>
                Select
              </option>
              <option value="Today">Today</option>
              <option value="Week">This Week</option>
              <option value="Month">This Month</option>
            </select>
          </div>
          {/* <div className="TitleBox m-0">
            <label>&nbsp;</label>
            <a
              className="TitleLink"
              onClick={() =>
                setUpdateState((prev) => ({
                  ...prev,
                  showCreatePost: true,
                }))
              }
            >
              <i className="fa-solid fa-plus" /> Create Post
            </a>
          </div> */}
        </div>
        <div className="NewFilter">
          <div
            className="SearchBox"
            style={{
              width: "60%",
            }}
          >
            <input
              type="search"
              className="SearchInput"
              placeholder="Search here by post id"
              name="searchQuery"
              value={searchQuery}
              onChange={(e) => handleSearch(e)}
            />
            <span>
              <i className="fa fa-search" />
            </span>
          </div>

          <div className="Actions">
            <div
              className="form-group"
              style={{
                textAlign: "center",
              }}
            >
              <select
                className="form-control FilterStatus"
                name="status"
                value={status}
                onChange={(e) => handleFilter(e)}
              >
                <option value="" hidden>
                  Filter by Status
                </option>
                <option value="ACTIVE">ACTIVE</option>
                <option value="INACTIVE">INACTIVE</option>
                <option value="pin">PIN</option>
                {/* <option value="unpin">Unpin</option> */}
              </select>
            </div>
            <button className="Button Cancel" onClick={handleReset}>
              <i className="fa fa-refresh" />
            </button>
            <ExportToExcel ref={feedRef} fileName="feeds" />
          </div>
        </div>
        <div className="TableList">
          <table className="table-hover" ref={feedRef}>
            <thead>
              <tr>
                <th>Sr. No</th>
                <th>Post ID</th>
                <th>Date &amp; Time of Post</th>
                <th>No of Likes</th>
                <th>No of Comments</th>
                <th>No of Shares</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {!loading ? (
                feed?.result?.[0]?.paginationData?.length > 0 ? (
                  feed?.result?.[0]?.paginationData.map((data, i) => {
                    return (
                      <tr key={data?._id}>
                        <td>{i + 1 + (page - 1) * 10}</td>
                        <td>{data?.post_number}</td>

                        <td>
                          {moment(data?.createdAt).format("DD-MM-YYYY, h:mm ")}
                        </td>
                        <td>{data?.likeCount}</td>
                        <td>
                          <a
                            className="BlueLink"
                            onClick={() => handleCommentList(data?._id)}
                          >
                            {data?.commentCount}
                          </a>
                        </td>
                        <td>10</td>
                        <td>
                          <span className="Green">
                            {data?.status == "ACTIVE" ? "Available" : "Removed"}
                          </span>
                        </td>
                        <td>
                          <div className="Actions">
                            <a
                              className="Eyes"
                              onClick={() => handleShow("showPost", data?._id)}
                            >
                              <i className="fa-regular fa-eye" />
                            </a>
                            <a
                              className={`${
                                data?.is_pinned == false ? "Delete" : "Filter"
                              }`}
                              onClick={() =>
                                pinManagement(
                                  data?._id,
                                  data?.is_pinned === false ? true : false
                                )
                              }
                            >
                              <img
                                src={require("../../../assets/images/pin.png")}
                              />
                            </a>
                            <a
                              className="Delete"
                              onClick={() =>
                                handleShow("deletePost", data?._id)
                              }
                            >
                              <i className="fa-regular fa-trash-can" />
                            </a>
                          </div>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={10}>No TimeLine Data</td>
                  </tr>
                )
              ) : (
                <TableSkeleton
                  length={feed?.result?.[0]?.paginationData?.length}
                />
              )}
            </tbody>
          </table>
        </div>
        <div className="Pagination">
          {feed?.result?.[0]?.totalCount?.[0]?.count > 0 && (
            <>
              <p>
                Showing {(page - 1) * 10 + 1} to{" "}
                {feed?.result?.[0]?.paginationData?.length + (page - 1) * 10} of{" "}
                {feed?.result?.[0]?.totalCount?.[0]?.count} results
              </p>
              <div className="PaginationRight">
                {feed?.result?.[0]?.totalCount?.[0]?.count > 0 && (
                  <CommonPagination
                    activePage={page}
                    itemsCountPerPage={10}
                    totalItemsCount={
                      feed?.result?.[0]?.totalCount?.[0]?.count || 0
                    }
                    pageRangeDisplayed={4}
                    onChange={handlePageChange}
                    itemClass="page-item"
                    linkClass="page-link"
                  />
                )}
              </div>
            </>
          )}
        </div>
      </div>

      {showPost && <ViewPost setUpdateState={setUpdateState} postId={id} />}
      {deletePost && (
        <DeletePost
          setUpdateState={setUpdateState}
          handleDelete={handleDelete}
        />
      )}
      {commentList && (
        <CommentListModal handleCommentClose={handleCommentClose} id={id} />
      )}
    </>
  );
};

export default TimelineDetails;
